import { AxiosRequestHeaders, AxiosResponse } from "axios";
import { GetCurrentLogin } from "../account/AccountStore";

import axios from "../general/HttpClient";

//@ts-ignore
const identityURL = identityServer;

const COVID_APP_TYPE = 5;

export function GetUserInfo() {
    return axios.get(`${identityURL}connect/userinfo`);
}

export function GetCurrentLoggedInUser() {
    return axios.get(`${identityURL}account/CurrentLoggedInUser`);
}

export function GetMyApplications(user) {
    let headers = { "x-sca-ide-org-context": user.getClaim("sca-organization") };

    if (!user.getClaim("sca-organization")) {
        delete headers["x-sca-ide-org-context"];
    }

    return axios.get(`${identityURL}api/Applications/GetMyApplications`, { params: { type: COVID_APP_TYPE }, headers });
}

export function ResolveUsers(users) {
    return axios.post(`${identityURL}api/Users/$resolve`, { users }).then((response) => {
        return response.data;
    });
}

export function SearchUsers(organizationID, query) {
    let headers = { "x-sca-ide-org-context": organizationID };

    return axios.get(`${identityURL}api/Users/searchUsers`, { params: { query }, headers }).then((response: AxiosResponse<GetIdentityOrganizationMembersResponse>) => {
        return response.data;
    });
}

export function GetIdentityGroups(organizationId) {
    return axios.get(`${identityURL}api/Groups/${organizationId}`).then((response) => {
        return response.data;
    });
}

export function GetIdentityGroupMembers(groupId) {
    return axios.get(`${identityURL}api/Groups/${groupId}/members`).then((response) => {
        return response.data;
    });
}

export function GetOrganizations() {
    return axios.get(`${identityURL}api/Organizations/`).then((response) => {
        return response.data;
    });
}

export async function GetOrganization(organizationId) {
    let user = await GetCurrentLogin();
    let headers = { "x-sca-ide-org-context": user.getClaim("sca-organization") } as any;

    if (!user.getClaim("sca-organization")) {
        delete headers["x-sca-ide-org-context"];
    }

    return axios.get(`${identityURL}api/Organizations/${organizationId}`, { headers }).then((response) => {
        return response.data;
    });
}

export class GetIdentityOrganizationMembersResponse {
    constructor() {
        this.members = [];
        this.total = 0;
    }

    members: IdentityUser[];
    total: number;
}

export interface IdentityUser {
    id: string;
    userName: string;
    email: string;
    firstName: string;
    lastName: string;
    fullName: string;
    displayName: string;
    hasGivenAccessTo: DelegatedAccess[];
    groups: IdentityGroup[];
    sourceID: string;
    source: string;
    organization: string;
    membershipType: number;
    photo: string;
}

export interface DelegatedAccess {
    delegatorID: string;
    delegateeID: string;
    delegationRules: string;
}

export interface SourceIdentifier {
    source: string;
    sourceID: string;
}

export interface IdentityGroup {
    id: string;
    name: string;
    type: number;
    source: string;
    sourceID: string;
    organizationID: string;
    groupCustomTypeID: string;
    groupCustomTypeName: string;
    groupCustomTypeSource: string;
    groupCustomTypeSourceID: string;
    description: string;
}
